import React from "react";
import Menu from "@material-ui/core/Menu";
import IconButton from "@material-ui/core/IconButton";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import Button from '@material-ui/core/Button';
import { useDownloadMenuStyles } from '@mui-treasury/styles/menu/download';


export default (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { button, horizontal } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const Button = button;
  const downloadMenuClasses = useDownloadMenuStyles();

  return (
    <div>
      {button ? <Button onClick={handleClick} /> : <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
          <GetAppRoundedIcon className={downloadMenuClasses.downloadIcon}/>
                                      <ExpandMoreIcon className={anchorEl ? downloadMenuClasses.downIcon : downloadMenuClasses.upIcon}/>
                                    
      </IconButton>}
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: horizontal ? horizontal : "center" }}
        // keepMounted
        open={Boolean(anchorEl)}
        onClick={handleClose}
      >
        {props.children}
      </Menu>
    </div>
  );
};
